/**
 * External dependencies
 */
import React from 'react';
import { Stack, Text } from '@towersystems/towersystems-design-system';
import Notice from '../../../../components/notice';

/**
 * Internal dependencies
 */

const RoamRender = ({ ...props }) => {
	return (
		<Stack space='medium'>
			<Text>Please use Roam platform to manage locations.</Text>
		</Stack>
	);
};

export default RoamRender;
